<!-- <div id="openExtendsServiceHotel" class="modal fade">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <p>Some text in the modal.</p>
      </div>
    </div>
  </div>
</div> -->

<div id="openExtendsServiceHotel" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Registrar servicio hotel</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-12">
                  <label>Nombre servicio<span class="required"></span></label>
                  <input type="text" id="item_description"
                    [ngClass]="{'parsley-error': (submitted && f['description'].errors)}" formControlName="description"
                    required="true" class="form-control">
                  <div *ngIf="submitted && f['description'].errors">
                    <small class="text-danger" *ngIf="f['description'].errors['required']">Nombre es requerido</small>
                    <small class="text-danger" *ngIf="f['description'].errors['minlength']">Nombre Muy corto</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal" (click)="close()">Cancelar</button>
          <button type="submit" class="btn btn-primary">Guardar </button>
        </div>
      </form>
    </div>
  </div>
</div>
